import { type IEvent } from '../platform/platform';

/**
 * Mutates the `event` to make sure it corresponds to `IEvent` interface, by
 * converting times to a common format for the goal of normalization.  Also makes
 * sure `cameras` and `videos` exist because VD expects them to always be there.
 *
 * @param event
 */
export function normalizeEvent(event: IEvent) {
  event.startTime = new Date(event.startTime);
  event.startTimeLocal = new Date(event.startTimeLocal);
  event.endTime = new Date(event.endTime);
  event.endTimeLocal = new Date(event.endTimeLocal);
  event.cameras = event.cameras || [];
  event.videos = event.videos || [];

  return event;
}
